import { Box } from '@qbe/ads-core';
import * as React from 'react';

import { TargetEnv, targetEnv } from '~/config';
import { Z_INDEX } from '~/customTokens';
import { useAppDetails } from '~/hooks';
import { Group } from '~/slices/appDetails';

const getBackgroundText = (groups: Group[]) => {
  const envStr = targetEnv === TargetEnv.prod ? undefined : targetEnv.toUpperCase();
  if (groups.includes('staff') || window.location.pathname.endsWith('/staff')) {
    return `STAFF${envStr ? ` ${envStr}` : ''}`;
  }
  return envStr;
};

const PageBackground = () => {
  const { groups } = useAppDetails();
  const backgroundText = getBackgroundText(groups);

  return (
    <Box
      sx={{
        zIndex: Z_INDEX.APP_BACKGROUND,
        position: 'fixed',
        opacity: 0.5,
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundImage: backgroundText
          ? `url("data:image/svg+xml;charset=UTF-8,%3csvg width='150' height='100' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3ctext x='10' y='20' fill='red' fill-opacity='0.3'%3e${backgroundText}%3c/text%3e%3c/svg%3e ");`
          : '',
      }}
    />
  );
};

export default PageBackground;
